export default __webpack_public_path__ + "static/media/verify_device_success.46ac11a6.png";